export default __webpack_public_path__ + "assets/images/integracaoddadcdc7aa2c1a91eb969ed5ee510ed0.png";